"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBLowerInterestPositive = function SvgBLowerInterestPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M25.358 117.203c-.55 0-1.08-.214-1.475-.598L.618 93.326a2.107 2.107 0 011.49-3.596h21.157V32.165a2.107 2.107 0 014.214 0v59.707a2.107 2.107 0 01-2.107 2.107H7.193l19.668 19.669a2.107 2.107 0 010 2.978c-.405.383-.945.59-1.503.577zM78.505 117.202a2.108 2.108 0 01-1.497-3.597l19.669-19.668H78.49a2.107 2.107 0 01-2.108-2.107v-9.94a2.107 2.107 0 114.215 0v7.84h21.157a2.107 2.107 0 011.49 3.596l-23.251 23.279a2.108 2.108 0 01-1.49.597zM25.372 20.926a2.107 2.107 0 01-2.107-2.108V2.171a2.107 2.107 0 014.214 0v16.647a2.107 2.107 0 01-2.107 2.108zM2.107 80.78A2.107 2.107 0 010 78.673V61.99a2.107 2.107 0 114.215 0v16.683a2.107 2.107 0 01-2.108 2.107zM51.896 143.768a2.107 2.107 0 01-1.489-.61l-16.585-16.586a2.107 2.107 0 01-.618-1.489V111.8a2.107 2.107 0 014.215 0v12.405l14.477 14.478 15.096-15.096a2.108 2.108 0 112.978 2.985l-16.585 16.585a2.107 2.107 0 01-1.489.611z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M78.49 133.934a2.107 2.107 0 01-2.107-2.107V108.45a2.107 2.107 0 014.215 0v23.377a2.107 2.107 0 01-2.107 2.107zM101.755 83.998a2.107 2.107 0 01-2.107-2.108v-3.33a2.107 2.107 0 114.215 0v3.33a2.107 2.107 0 01-2.108 2.108z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M46.796 27.634a2.185 2.185 0 01-.625-.098 2.107 2.107 0 01-1.405-2.642A35.466 35.466 0 0192.532 2.852a2.107 2.107 0 01-1.664 3.87 31.252 31.252 0 00-42.056 19.43 2.107 2.107 0 01-2.016 1.482zM78.624 70.862c-15.53.058-29.27-10.05-33.836-24.894a2.107 2.107 0 014.024-1.25 31.216 31.216 0 1051.939-31.301 2.111 2.111 0 012.992-2.979 35.438 35.438 0 01-25.119 60.41v.014z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M66.661 31.61a8.127 8.127 0 110-16.255 8.12 8.12 0 018.12 8.128 8.141 8.141 0 01-8.113 8.127h-.007zm0-12.04a3.913 3.913 0 000 7.825 3.913 3.913 0 002.761-6.68 3.87 3.87 0 00-2.754-1.152l-.007.007zM90.615 54.51a8.127 8.127 0 010-16.248 8.127 8.127 0 018.092 8.099 8.134 8.134 0 01-8.092 8.148zm0-12.034a3.92 3.92 0 00-3.941 3.885 3.913 3.913 0 003.94 3.934 3.913 3.913 0 000-7.819zM51.819 37.545H38.557a2.107 2.107 0 010-4.214h13.262a2.107 2.107 0 110 4.214zM61.948 54.221a2.107 2.107 0 01-1.49-3.603l40.237-40.229a2.107 2.107 0 012.978 2.957L63.437 53.603c-.395.395-.93.618-1.489.618z",
    fill: "#285"
  })));
};

var _default = SvgBLowerInterestPositive;
exports["default"] = _default;